var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.00519941 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C24 10.4241 23.6896 8.8637 23.0866 7.4078C22.4835 5.95189 21.5996 4.62902 20.4853 3.51472C19.371 2.40041 18.0481 1.5165 16.5922 0.913445C15.1363 0.310389 13.5759 0 12 0ZM12 21.6C10.1013 21.6 8.24524 21.037 6.66653 19.9821C5.08782 18.9272 3.85736 17.4279 3.13076 15.6738C2.40416 13.9196 2.21405 11.9893 2.58447 10.1271C2.95488 8.26491 3.86919 6.55436 5.21178 5.21177C6.55436 3.86919 8.26492 2.95488 10.1271 2.58446C11.9894 2.21404 13.9196 2.40415 15.6738 3.13076C17.4279 3.85736 18.9272 5.08781 19.9821 6.66652C21.037 8.24524 21.6 10.1013 21.6 12C21.6 14.5461 20.5886 16.9879 18.7882 18.7882C16.9879 20.5886 14.5461 21.6 12 21.6Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic-locker-open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-86",
    d: "M8.81 10.7147V14.3188C8.81 14.5617 8.99148 14.7667 9.21535 14.7667H14.8846C15.1099 14.7667 15.29 14.5662 15.29 14.3188V10.7147C15.29 10.4718 15.1085 10.2667 14.8846 10.2667H9.21535C8.99008 10.2667 8.81 10.4673 8.81 10.7147ZM8 10.7147C8 9.96908 8.54377 9.36675 9.21535 9.36675H14.8846C15.5547 9.36675 16.1 9.97347 16.1 10.7147V14.3188C16.1 15.0644 15.5562 15.6667 14.8846 15.6667H9.21535C8.54527 15.6667 8 15.06 8 14.3188V10.7147ZM17 9.36675H16.1C16.1 8.37264 15.2941 7.56675 14.3 7.56675C13.3059 7.56675 12.5 8.37264 12.5 9.36675H11.6C11.6 7.87558 12.8088 6.66675 14.3 6.66675C15.7912 6.66675 17 7.87558 17 9.36675ZM12.05 12.9667C12.2985 12.9667 12.5 12.7653 12.5 12.5167C12.5 12.2682 12.2985 12.0667 12.05 12.0667C11.8015 12.0667 11.6 12.2682 11.6 12.5167C11.6 12.7653 11.8015 12.9667 12.05 12.9667Z",
    fill: "#8B8B8B",
    stroke: "#8B8B8B",
    strokeWidth: 0.4,
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/ResetIcon.20d91a21a8fff51bd46d785592f0af10.svg";
export { ForwardRef as ReactComponent };